import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import TreeView from "./TreeView";
import classNames from "classnames";
import { hasValue } from "@utils";
import Modal from "@widget/popups/Modal";
import Button from "@widget/buttons/Button";
import './TreeViewSelect.scss';
/**
 * @export
 *
 * Select component with treeview
 */
const TreeViewSelectInput = React.forwardRef((props, ref) => {
    const { selected, multiSelect, placeholder, showSelectedNodePath, showSelectedNodeDisplayPath, onSelect } = props;
    const [showPicker, setShowPicker] = useState(false);
    useEffect(() => {
    }, [selected]);
    function renderNodeLabel(node) {
        var _a;
        return showSelectedNodePath
            ? node === null || node === void 0 ? void 0 : node.path
            : showSelectedNodeDisplayPath
                ? node === null || node === void 0 ? void 0 : node.displayPath
                : (node === null || node === void 0 ? void 0 : node.renderLabel)
                    ? (_a = node === null || node === void 0 ? void 0 : node.renderLabel) === null || _a === void 0 ? void 0 : _a.call(node)
                    : node.label;
    }
    function renderSelected() {
        if (multiSelect && selected instanceof Array && (selected === null || selected === void 0 ? void 0 : selected.length) > 0) {
            return selected.map(node => {
                return _jsx("div", { className: "uxpcore_treeview_select__selected-node", children: renderNodeLabel(node) });
            });
        }
        else if (!multiSelect && hasValue(selected))
            return renderNodeLabel(selected);
        return hasValue(placeholder) ? placeholder : multiSelect ? 'Select one or more items' : 'Select an item';
    }
    function handleSelect(selected) {
        onSelect(selected);
        if (!multiSelect)
            setShowPicker(false);
    }
    return _jsxs("div", { className: classNames('uxpcore_treeview_select__container'), children: [_jsx("div", { className: "uxpcore_treeview_select__placeholder", onClick: () => setShowPicker(true), children: _jsx("div", { className: classNames('uxpcore_treeview_select__selected', { 'uxpcore_treeview_select__selected--multiple': multiSelect }), children: renderSelected() }) }), _jsxs(Modal, { title: hasValue(placeholder) ? placeholder : multiSelect ? 'Select one or more items' : 'Select an item', show: showPicker, onClose: () => { setShowPicker(false); }, className: classNames("uxpcore_treeview_select__modal", { 'uxpcore_treeview_select__modal--has-footer': multiSelect }), children: [_jsx(TreeView, Object.assign({}, props, { onSelect: handleSelect })), multiSelect ?
                        _jsx("div", { className: "uxpcore_treeview_select__modal__footer", children: _jsx(Button, { title: "Done", onClick: () => setShowPicker(false) }) })
                        : null] })] });
});
export default TreeViewSelectInput;
